<template>
  <div>
    <a v-if="active" class="hover-help" :title="'Filter'|t"><i class="icon icon-filter" @click="doFilter"></i> </a>
    <span v-html="display"></span>
  </div>
</template>

<script>

  export default {
    name: 'LogField',
    props: {
      filter: {
        type: Object,
        required: true,
      },
      display: {
        type: String,
        required: true,
      },
      active: {
        type: Boolean,
        default() {return  false}
      }
    },
    methods: {
      doFilter() {
        this.$emit('change', this.filter);
        this.$emit('submit', this.filter);
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/LogField.vue